export const INITIAL_CHAT_METADATA = {
  owner: null,
  source: 'User Chat',
  user_created: null,
  date_created: null,
  linked_widget: null,
  thread_id: null,
  assistant_id: null,
  linkedlead: null,
  overall_sentiment: null,
  overall_sentiment_rationale: null,
  overall_sentiment_topics: null,
  title: null,
  intensity_score: null,
  business_risk: null,
  confidence: null,
  messages_count: null,
  opening_valence: null,
  closing_valence: null,
  delta_valence: null,
  delta_open_to_close: null,
  closing_missing: null,
  exit_intent: null,
  resolution_status: null,
  loop_detected: null,
  loop_count: null,
  core_min_valence: null,
  primary_intent: null,
  intent_fulfilled: null,
  effort_score: null,
  priority_band: null,
  no_progress_loop: null,
  recommended_action: null,
  tags: null,
  judge_output: null,
  failed_recovery: null,
  unsupported_promise: null,
  turning_point: null,
  turning_point_turn_id: null,
  turning_point_direction: null,
  turning_point_trigger: null
};
